import React, { useEffect } from "react";

import Details from "../details/Details";
import { useNavigate } from "react-router-dom";
import HppWrapper from "./HppWrapper";
import { useTranslation } from "react-i18next";
import { getCurrencyIconImg } from "../../utils/helper";
import Loader from "../loader/Loader.component";
import PayNowQrDisplay from "../paynow-button/PayNowQrDisplay";
import QrphQrDisplay from "../qrph-button/QrphQrDisplay";
import WalletButtons from "./WalletButtons";
import { PendingTickIcon } from "../form/form-fields/InputStatusIcon";

const LangWrapper = ({
  isIbec = false,
  apiData,
  children,
  pblProduct,
  subscriptionProduct,
  setApiData,
  setAmountPopup,
  handleApplePayClick,
  slug,
  setDasLoader,
  showOnlyHPPForm = false,
  allTrue,
  payNowQr = null,
  qrphQr = null,
  onPayNowQrGenerated,
  onPayNowBack,
  onQrphQrGenerated,
  onQrphBack,
}: any) => {
  const { address: ADDRESS, company: COMPANY } = apiData;
  const navigate = useNavigate();
  useEffect(() => {
    setDasLoader(true);
    let transactioContext: any = localStorage.getItem("transactionContext");
    try {
      transactioContext = JSON.parse(transactioContext);
    } catch (error) {}
    if (transactioContext) {
      if (isIbec) {
        const redirect_url = transactioContext.return_url.decline_url;
        localStorage.removeItem("transactionContext");
        if (redirect_url && localStorage.getItem("slug") === slug)
          window.location.href = redirect_url;
      } else {
        localStorage.removeItem("transactionContext");
      }
    }
    setDasLoader(false);
  }, []);

  const AMOUNT = `${apiData?.amount}`;

  const { t } = useTranslation();
  const hideQrLanguageSwitcher = Boolean(payNowQr || qrphQr);
  if (
    localStorage.getItem("transactionContext") &&
    isIbec &&
    localStorage.getItem("slug") === slug
  ) {
    return (
      <>
        <Loader />
      </>
    );
  }
  return (
    <HppWrapper
      apiData={apiData}
      allTrue={allTrue}
      hideLanguageSwitcher={hideQrLanguageSwitcher}
    >
      <div className="flex-section">
        <div className="additional-product">
          {subscriptionProduct && subscriptionProduct}
          {pblProduct && pblProduct}
        </div>
        <div className="form-div">
          {!payNowQr && !qrphQr && (
            <Details COMPANY={COMPANY || ""} ADDRESS={ADDRESS || ""} />
          )}

          {!allTrue && !payNowQr && !qrphQr && (
            <div className="show-only-apple-pay-and-google-pay-button">
              <label>
                {t("merchant.Payment_Information.fields.Amount")}
              </label>
              <div className="gpay-appay-amount-div">
                <div className="gpay-appay-amount-field">
                  <span>{AMOUNT}</span>
                  <span>
                    {["JPY", "SGD", "HKD", "USD"].includes(
                      apiData?.currency
                    ) ? (
                      <img
                        className="currency-img-icon"
                        src={getCurrencyIconImg(apiData?.currency)}
                        alt={apiData?.currency}
                      />
                    ) : (
                      <p>{apiData?.currency}</p>
                    )}
                  </span>
                  <span className="inputcheck">
                    <PendingTickIcon />
                  </span>
                </div>
              </div>
              <WalletButtons
                isIbec={isIbec}
                allTrue={allTrue}
                apiData={apiData}
                setApiData={setApiData}
                setAmountPopup={setAmountPopup}
                handleApplePayClick={handleApplePayClick}
                slug={slug}
                setDasLoader={setDasLoader}
                onPayNowQrGenerated={onPayNowQrGenerated}
                onQrphQrGenerated={onQrphQrGenerated}
              />
            </div>
          )}

          {payNowQr ? (
            <PayNowQrDisplay
              qrImage={payNowQr.qrImage}
              amount={payNowQr.amount ?? apiData?.amount}
              currency={payNowQr.currency ?? apiData?.currency}
              merchantName={payNowQr.merchantName ?? apiData?.company}
              address={apiData?.address}
              transactionId={payNowQr.uuid || payNowQr.transactionID}
              onBack={onPayNowBack}
              navigate={navigate}
            />
          ) : (
            qrphQr ? (
              <QrphQrDisplay
                qrImage={qrphQr.qrImage}
                amount={qrphQr.amount ?? apiData?.amount}
                currency={qrphQr.currency ?? apiData?.currency}
                merchantName={qrphQr.merchantName ?? apiData?.company}
                address={apiData?.address}
                transactionId={qrphQr.uuid || qrphQr.transactionID}
                onBack={onQrphBack}
                navigate={navigate}
              />
            ) : (
              allTrue && children
            )
          )}
        </div>
      </div>
    </HppWrapper>
  );
};

export default LangWrapper;
